import React, { Component } from 'react'
import { withFileInput } from '../../../utils/form'
import Field from '../../common/FormField'
import CurrentImage from './CurrentImage'
import styles from '../../retailer/Form.module.css'

const StoreMasthead = ({
  imageMasthead,
  disabled,
  fileName,
  previewUrl,
  handleFileInputChange,
  onDeleteMastheadImage
}) =>
  <fieldset>
    <Field type="input input-file">
      <div className="button">
        <input
          type="file"
          accept="image/jpeg, image/png"
          onChange={handleFileInputChange}
          disabled={disabled}
        />
        BROWSE
      </div>
      <input
        type="text"
        placeholder="Upload a masthead image (optional)"
        value={fileName}
        readOnly
      />
    </Field>
    {previewUrl && (
      <div className={styles.imagePreview}>
        <img src={previewUrl} alt="Preview" />
        <div className={styles.imagePreviewLabel}>New image preview — will be saved on submit</div>
      </div>
    )}
    {!previewUrl && imageMasthead
      ? <CurrentImage
          path={imageMasthead.get('path')}
          onDelete={onDeleteMastheadImage}
          disabled={disabled}
        />
      : null}
  </fieldset>

export default withFileInput(StoreMasthead)
